import React from 'react';
import { Skeleton } from 'antd';
import ImageCard from '../ImageCard';
import Wrapper from '../Wrapper';
import './CourseDetail.less';

const CourseDetailSkeleton: React.FC = () => {
  return (
    <div className="skeleton-course-detail-container">
      <ImageCard cover={<Skeleton.Image className="skeleton-cover-image" />}>
        <Wrapper mb={1} display="flex" alignItems="center">
          <Wrapper mr={1}>
            <Skeleton.Image className="skeleton-image" />
          </Wrapper>
          <Skeleton round active paragraph={{ rows: 1 }} />
        </Wrapper>
      </ImageCard>
    </div>
  );
};

export default CourseDetailSkeleton;
